import { render, staticRenderFns } from "./fileLibrary.vue?vue&type=template&id=6f8b4b30&scoped=true"
import script from "./fileLibrary.vue?vue&type=script&lang=js"
export * from "./fileLibrary.vue?vue&type=script&lang=js"
import style0 from "./fileLibrary.vue?vue&type=style&index=0&id=6f8b4b30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8b4b30",
  null
  
)

export default component.exports